import React from "react";

const HttpContext = React.createContext({ status: 200 });

export default HttpContext;
